import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Typography, Box, Paper, withStyles,
} from '@material-ui/core';
import PF2MSelectOption from '~/components/PF2MSelectOption';
import PF2MAutocomplete from '~/components/PF2MAutocomplete';
import styles from './styles';

export const SelectMultiple = ({
  description,
  options,
  multiple,
  disabled,
  onChange,
  value,
  selectAllValue,
  classes,
}) => {
  const selectedOptions = options.filter(opt => (value || []).includes(opt.value));

  return (
    <>
      <Box className={classes.boxDescription}>
        <Typography className={classes.descriptionText}>
          {description}
        </Typography>
        <PF2MAutocomplete
          title={''}
          multiple={multiple}
          disabled={disabled}
          options={options}
          onChange={onChange}
          value={selectedOptions}
          selectAllValue={selectAllValue}
          limitTags={1}
          disablePortal
          classes={{
            paper: classes.autocompletePaperMargin,
          }}
          style={{ width: '100%' }}
        />
      </Box>
    </>
  );
};

const EquipmentFiltersSelect = memo(
  ({
    classes,
    formFields,
    handleChange,
    handleChangeMultiple,
  }) => {
    const SELECT_ALL_ID = -9999;
    const currentFilter = useSelector(
      state => state.dispatch.currentEquipmentStatusFilterV3,
    );

    return (
      <div className={classes.containerEquipFilters}>
        <Paper className={classes.filterMenu}>
          {formFields.map(field => (
            <React.Fragment key={field.key}>
              {field.component === 'singleSelect' && (
                <PF2MSelectOption
                  description={field.description}
                  options={field.options}
                  descriptionClassName={classes.descriptionText}
                  boxDescriptionClassName={classes.boxDescription}
                  onChange={e => handleChange({
                    value: e.target.value,
                    key: field.key,
                  })
                  }
                  value={currentFilter?.[field.key] || 0}
                  disabled={
                    field.dependsOn && !currentFilter?.[field.dependsOn]
                  }
                />
              )}
              {field.component === 'multiSelect' && (
                <SelectMultiple
                  description={field.description}
                  options={field.options}
                  multiple
                  classes={classes}
                  disabled={
                    field.dependsOn && !currentFilter?.[field.dependsOn]
                  }
                  onChange={(_, val) => handleChangeMultiple({ value: val, key: field.key })
                  }
                  value={currentFilter?.[field.key]}
                  selectAllValue={
                    field.key === 'code_id' ? SELECT_ALL_ID : -1
                  }
                />
              )}
            </React.Fragment>
          ))}
        </Paper>
      </div>
    );
  },
);

export default withStyles(styles)(EquipmentFiltersSelect);

SelectMultiple.propTypes = {
  description: PropTypes.string,
  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
  selectAllValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  classes: PropTypes.object.isRequired,
};

SelectMultiple.defaultProps = {
  description: '',
  multiple: false,
  disabled: false,
  value: [],
  selectAllValue: -1,
};

EquipmentFiltersSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  formFields: PropTypes.arrayOf(PropTypes.object),
  handleChange: PropTypes.func.isRequired,
  handleChangeMultiple: PropTypes.func.isRequired,
};

EquipmentFiltersSelect.defaultProps = {
  formFields: [],
};
